import { ChangeEvent, useMemo } from "react";

import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { resources } from "@constants/hardcoded-strings";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { RelyingPartyDetailsGeneralInfoValidationErrors } from "@idw-types/common/validation/relying-party/relying-party-details/relying-party-details-validation-errors";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { FormattedRelyingPartyConfig } from "@idw-types/data/relying-party-config";
import { OrganizationSelectFormGroup } from "@containers/common/select-form-groups";
import { SelectOption } from "@iddataweb/idw-common-ui/types";

type RelyingPartyDetailsGeneralTabProps = {
    requestInProgress: boolean;
    axnCompanies: Array<AxnCompany>;
    state: FormattedRelyingPartyConfig;
    setState: (state: FormattedRelyingPartyConfig) => void;
    labelWidth: LabelWidthTypes;
    validationErrors: RelyingPartyDetailsGeneralInfoValidationErrors;
}

export const RelyingPartyDetailsGeneralTab = (props: RelyingPartyDetailsGeneralTabProps) => {
    const {
        requestInProgress,
        axnCompanies,
        state,
        labelWidth,
        validationErrors,
        setState
    } = props;

    const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            name: event.target.value
        });
    };

    const handleBlockBuyCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            contractCode: event.target.value
        });
    };

    const selectedOrganizationOption: SelectOption = useMemo(() => {
        if (state.company) {
            return { label: state.company.name, value: state.company.id };
        }

        return null;
    }, [state.company]);

    const resource = resources.pages.relyingPartyDetails.tabs.details;

    return (
        <div>
            <ContentPageHeader title={resource.title} />
            <ContentPageBody isMaxWidth={true}>
                <InputFormGroup
                    controlId="relying-party-name-input"
                    automationId={"relying-party-name-input"}
                    label={resource.inputs.name.label}
                    ariaLabel={resource.inputs.name.label}
                    value={state.name}
                    disabled={requestInProgress || !state.permissions.canModify}
                    isRequired={true}
                    labelWidth={labelWidth}
                    placeholder={resource.inputs.name.label}
                    onChange={handleNameChange}
                />
                {validationErrors.relyingPartyNameError}
                <OrganizationSelectFormGroup
                    idPrefix="relying-party"
                    axnCompanies={axnCompanies}
                    isClearable={false}
                    isRequired={true}
                    isSearchable={true}
                    labelWidth={labelWidth}
                    selectedOption={selectedOrganizationOption}
                    onChange={() => { }}
                    disabled={true}
                />
                <InputFormGroup
                    controlId="relying-party-block-buy-code-input"
                    automationId={"relying-party-block-buy-code-input"}
                    label={resource.inputs.blockBuyCode.label}
                    ariaLabel={resource.inputs.blockBuyCode.label}
                    value={state.contractCode || ""}
                    disabled={requestInProgress || !state.permissions.canModify || !state.permissions.canModifyBlockBuyCode}
                    isRequired={false}
                    labelWidth={labelWidth}
                    placeholder={resource.inputs.blockBuyCode.label}
                    onChange={handleBlockBuyCodeChange}
                />
            </ContentPageBody>
        </div>
    );
}